// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.graph-load-view__field {
  width: calc(100% - 40px);
  margin: 0 20px;
  padding: 13px 0 10px;
  display: flex;
  position: absolute;
  right: 0;
}

.graph-load-view__field:after {
  content: "";
  border-bottom: 1px solid var(--lightgray-d);
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
}

.graph-load-view__field-input {
  background: none;
  border: 0;
  width: 100%;
  margin-left: 9px;
}

.graph-load-view__field-input:focus {
  outline: none;
}

.graph-load-view__dropdown {
  z-index: 2;
  background: #fff;
  border-left: 1px solid #d6d6d6;
  flex-direction: column;
  width: 360px;
  height: calc(100vh - 50px);
  transition: width .1s linear;
  display: flex;
  position: absolute;
  top: 0;
  right: 40px;
}

.graph-load-view__scrollbars {
  margin-top: 41px;
}

.graph-load-view__preview {
  z-index: 1;
  background: #fff;
  justify-content: center;
  align-items: center;
  max-width: 100%;
  padding: 20px;
  display: flex;
  position: absolute;
  inset: 0 400px 0 0;
}

.graph-load-view__preview img {
  image-rendering: -webkit-optimize-contrast;
  image-rendering: crisp-edges;
}

.graph-load-view__item {
  height: 90px;
  padding: 0 20px;
}

.graph-load-view__item:nth-child(2n) {
  background-color: #f5f5f5;
}

.graph-load-view__item:hover, .graph-load-view__item--selected {
  background-color: #dcdcdc;
}

.graph-load-view__item-separator {
  border-left: 1px solid #bbb;
  align-self: center;
  height: 20px;
  margin: 0 10px;
}

.graph-save-view__spinner-wrapper {
  justify-content: center;
  align-items: center;
  width: 16px;
  height: 16px;
  display: flex;
}

.graph-save-view__view-name {
  font-size: 13px;
  font-weight: 700;
}

.graph-save-view__view-info-text {
  font-size: 11px;
  font-weight: 700;
}

.graph-toolbar__save-as-form-control-button {
  top: 4px;
}
`, "",{"version":3,"sources":["webpack://./home/autoboss/ipfabric-product/services/frontend/app/components/Graph/GraphView/styles.css","webpack://./services/frontend/app/components/Graph/GraphView/styles.css"],"names":[],"mappings":"AADA;ECEE,wBAAwB;EACxB,cAAc;EACd,oBAAoB;EACpB,aAAa;EACb,kBAAkB;EAClB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,2CAA2C;EAC3C,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,8BAA8B;EAC9B,sBAAsB;EACtB,YAAY;EACZ,0BAA0B;EAC1B,4BAA4B;EAC5B,aAAa;EACb,kBAAkB;EAClB,MAAM;EACN,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,aAAa;EACb,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,0CAA0C;EAC1C,4BAA4B;AAC9B;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,kBAAkB;EAClB,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,QAAQ;AACV","sourcesContent":[".graph-load-view__field {\n  margin: 0 20px;\n  padding: 13px 0 10px;\n  display: flex;\n  width: calc(100% - 40px);\n  position: absolute;\n  right: 0;\n}\n\n  .graph-load-view__field:after {\n    content: '';\n    position: absolute;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    border-bottom: 1px solid var(--lightgray-d);\n  }\n\n.graph-load-view__field-input {\n  background: none;\n  border: 0;\n  margin-left: 9px;\n  width: 100%;\n}\n\n.graph-load-view__field-input:focus {\n    outline: none;\n  }\n\n.graph-load-view__dropdown {\n  height: calc(100vh - 50px);\n  width: 360px;\n  position: absolute;\n  right: 40px;\n  top: 0;\n  z-index: 2;\n  background: #fff;\n  border-left: 1px solid #d6d6d6;\n  transition: width 100ms linear;\n  display: flex;\n  flex-direction: column;\n}\n\n.graph-load-view__scrollbars {\n  margin-top: 41px;\n}\n\n.graph-load-view__preview {\n  position: absolute;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  left: 0;\n  top: 0;\n  bottom: 0;\n  right: 400px;\n  z-index: 1;\n  max-width: 100%;\n  background: #fff;\n  padding: 20px;\n}\n\n.graph-load-view__preview img {\n    image-rendering: -webkit-optimize-contrast;\n    image-rendering: crisp-edges;\n  }\n\n.graph-load-view__item {\n  height: 90px;\n  padding: 0 20px;\n}\n\n.graph-load-view__item:nth-child(even) {\n    background-color: #f5f5f5;\n  }\n\n.graph-load-view__item:hover {\n    background-color: #dcdcdc;\n  }\n\n.graph-load-view__item--selected {\n  background-color: #dcdcdc;\n}\n\n.graph-load-view__item-separator {\n  height: 20px;\n  border-left: 1px solid #bbbbbb;\n  margin: 0 10px;\n  align-self: center;\n}\n\n.graph-save-view__spinner-wrapper {\n  height: 16px;\n  width: 16px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.graph-save-view__view-name {\n  font-size: 13px;\n  font-weight: 700;\n}\n\n.graph-save-view__view-info-text {\n  font-size: 11px;\n  font-weight: 700;\n}\n\n.graph-toolbar__save-as-form-control-button {\n  top: 4px;\n}\n",".graph-load-view__field {\n  width: calc(100% - 40px);\n  margin: 0 20px;\n  padding: 13px 0 10px;\n  display: flex;\n  position: absolute;\n  right: 0;\n}\n\n.graph-load-view__field:after {\n  content: \"\";\n  border-bottom: 1px solid var(--lightgray-d);\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  right: 0;\n}\n\n.graph-load-view__field-input {\n  background: none;\n  border: 0;\n  width: 100%;\n  margin-left: 9px;\n}\n\n.graph-load-view__field-input:focus {\n  outline: none;\n}\n\n.graph-load-view__dropdown {\n  z-index: 2;\n  background: #fff;\n  border-left: 1px solid #d6d6d6;\n  flex-direction: column;\n  width: 360px;\n  height: calc(100vh - 50px);\n  transition: width .1s linear;\n  display: flex;\n  position: absolute;\n  top: 0;\n  right: 40px;\n}\n\n.graph-load-view__scrollbars {\n  margin-top: 41px;\n}\n\n.graph-load-view__preview {\n  z-index: 1;\n  background: #fff;\n  justify-content: center;\n  align-items: center;\n  max-width: 100%;\n  padding: 20px;\n  display: flex;\n  position: absolute;\n  inset: 0 400px 0 0;\n}\n\n.graph-load-view__preview img {\n  image-rendering: -webkit-optimize-contrast;\n  image-rendering: crisp-edges;\n}\n\n.graph-load-view__item {\n  height: 90px;\n  padding: 0 20px;\n}\n\n.graph-load-view__item:nth-child(2n) {\n  background-color: #f5f5f5;\n}\n\n.graph-load-view__item:hover, .graph-load-view__item--selected {\n  background-color: #dcdcdc;\n}\n\n.graph-load-view__item-separator {\n  border-left: 1px solid #bbb;\n  align-self: center;\n  height: 20px;\n  margin: 0 10px;\n}\n\n.graph-save-view__spinner-wrapper {\n  justify-content: center;\n  align-items: center;\n  width: 16px;\n  height: 16px;\n  display: flex;\n}\n\n.graph-save-view__view-name {\n  font-size: 13px;\n  font-weight: 700;\n}\n\n.graph-save-view__view-info-text {\n  font-size: 11px;\n  font-weight: 700;\n}\n\n.graph-toolbar__save-as-form-control-button {\n  top: 4px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
